import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { StepIndicator } from '../components/StepIndicator';
import '../styles/jobApplicationIntro.scss';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LockIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const FALLBACK_CONTENT = {
  description: 'مرحبًا بك في نموذج التقديم على الوظيفة. ستحتاج خلال الخطوات القادمة إلى إدخال بياناتك الشخصية والتحقق من رقم هاتفك عبر رمز التحقق (OTP)، وبعد إرسال الطلب بنجاح ستحصل على رقم مرجعي ورمز QR خاص بطلبك يمكنك حفظه والرجوع إليه لاحقًا.',
  terms: 'بتقديمك لهذا الطلب فإنك تقر بصحة جميع البيانات المدخلة، وتوافق على قيام الشركة بالتواصل معك عبر رقم الهاتف المُدخل لأغراض متابعة طلب التوظيف.',
  generalInfo: '',
  requiredDocuments: [],
  registrationOpen: true,
  existingApplicantsOnly: false,
  isFull: false
};

const TABS = [
  { id: 'terms', label: 'شروط القبول' },
  { id: 'general', label: 'معلومات عامة' },
  { id: 'documents', label: 'المستندات المطلوبة' }
];

export const JobApplicationIntro = () => {
  const [agreed, setAgreed] = useState(false);
  const [content, setContent] = useState(FALLBACK_CONTENT);
  const [activeTab, setActiveTab] = useState('terms');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/website/content`);
        if (!res.ok) return;
        const json = await res.json();
        setContent(json);
      } catch (err) {
        // Keep the fallback copy if the content couldn't be fetched
      }
    };
    fetchContent();
  }, []);

  // While closed, existingApplicantsOnly lets whoever already has a
  // pending OTP through to the form — the max-applications cap still
  // blocks everyone regardless.
  const isBlocked = (!content.registrationOpen && !content.existingApplicantsOnly) || content.isFull;

  const handleContinue = () => {
    if (!agreed || isBlocked) return;
    navigate('/apply');
  };

  return (
    <div className="intro-page">
      <div className="intro-container">
        <div className="logo">
          <img src="/images/logo-2.png" alt="شعار إدارة التجنيد والاحتياط" />
        </div>

        <StepIndicator currentStep={1} />

        <h1>منصة قبول طلبة الكليات العسكرية لسنة 2026 - 2027</h1>
        <p className="intro-text">{content.description}</p>

        {isBlocked && (
          <div className="closed-notice">
            <LockIcon />
            <span>
              {!content.registrationOpen
                ? 'التسجيل مغلق حالياً'
                : 'تم الوصول للحد الأقصى من عدد الطلبات المسموح بها'}
            </span>
          </div>
        )}

        <div className="content-tabs" role="tablist">
          {TABS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              className={`content-tabs__btn ${activeTab === tab.id ? 'active' : ''}`}
              aria-selected={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="tab-panel" tabIndex={0}>
          {activeTab === 'terms' && <p className="tab-panel__text">{content.terms}</p>}
          {activeTab === 'general' && <p className="tab-panel__text">{content.generalInfo}</p>}
          {activeTab === 'documents' && (
            content.requiredDocuments && content.requiredDocuments.length > 0 ? (
              <ul className="tab-panel__list">
                {content.requiredDocuments.map((doc, index) => (
                  <li key={index}>{doc}</li>
                ))}
              </ul>
            ) : (
              <p className="tab-panel__text">لا توجد مستندات مضافة حالياً</p>
            )
          )}
        </div>

        <label className="agree-checkbox">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
            disabled={isBlocked}
          />
          <span>لقد قرأت ووافقت على شروط القبول</span>
        </label>

        <button
          type="button"
          className="continue-btn"
          disabled={!agreed || isBlocked}
          onClick={handleContinue}
        >
          الاستمرار
        </button>
      </div>
    </div>
  );
};

export default JobApplicationIntro;
